var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.008 28.465c7.71 0 14-6.235 14-14 0-7.711-6.29-14-14-14-7.766 0-14 6.289-14 14 0 7.765 6.234 14 14 14zm6.18-16.57l-7 7c-.547.546-1.368.546-1.86 0l-3.5-3.5a1.198 1.198 0 010-1.806c.492-.546 1.313-.546 1.86 0l2.57 2.57 6.07-6.124a1.287 1.287 0 011.805 0c.547.547.547 1.367 0 1.86h.055z"
  })));
}
export default SvgCheck3;